export namespace Token {
  interface ITokenPayload {
    [key: string]: number;
    iat: number;
    exp: number;
  }

  export const getPayload = (token: string): ITokenPayload | void => {
    if (token && token.split('.').length === 3) {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(decodeURIComponent(encodeURIComponent(window.atob(base64))));
      } catch (e) {
        return undefined;
      }
    }
  };

  export const getExpirationDate = (token: string): Date => {
    const payload = getPayload(token);
    const date = new Date(0);

    date.setUTCSeconds(payload ? payload.exp : 0);

    return date;
  };

  export const isExpired = (token: string): boolean => {
    const expirationDate: Date = getExpirationDate(token);

    return expirationDate.valueOf() <= new Date().valueOf();
  };
}
